export default "__VITE_ASSET__DwDCUxOM__"